import { Image, Box } from '@chakra-ui/react';

type ImageButtonProps = {
  imageSrc: string;
  title: string;
  onClick: () => void;
  isSelected?: boolean;
};

const ImageButton = ({
  title,
  imageSrc,
  onClick,
  isSelected,
}: ImageButtonProps) => {
  return (
    <Box as={'button'} borderRadius={'xl'} onClick={onClick}>
      <Image
        src={imageSrc}
        objectFit={'contain'}
        position={'relative'}
        borderRadius={'xl'}
        opacity={isSelected ? 0.8 : 0.2}
      ></Image>
      <Box
        position={'absolute'}
        textColor={'white'}
        as={'b'}
        width={'70%'}
        top={'40%'}
        right={'15%'}
      >
        {title}
      </Box>
    </Box>
  );
};

export default ImageButton;
